__turbopack_context__.v({
  "heroCtaContainer": "hero-cta-module-scss-module__ekGVQa__heroCtaContainer",
  "heroCtaLayout": "hero-cta-module-scss-module__ekGVQa__heroCtaLayout",
  "heroCtaText": "hero-cta-module-scss-module__ekGVQa__heroCtaText",
  "hero_cta_button": "hero-cta-module-scss-module__ekGVQa__hero_cta_button",
});
